import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

const routes: Routes = [

  {
    path: '',
    redirectTo: environment.PAGES.horario.url,
    pathMatch: 'full',
  },
  {
    path: '/horario',
    redirectTo: environment.PAGES.horario.url,
    pathMatch: 'full',
  },
  {
    path: environment.PAGES.horario.url,
    loadChildren: () =>
      import('./project/pages/horario/horario.module').then(
        (m) => m.HorarioPageModule
      ),
  },
  {
    path: 'horario',
    loadChildren: () =>
      import('./project/pages/horario/horario.module').then(
        (m) => m.HorarioPageModule
      ),
  },
  {
    path: 'popover-bloque-horario',
    loadChildren: () =>
      import(
        './project/pages/popover-bloque-horario/popover-bloque-horario.module'
      ).then((m) => m.PopoverBloqueHorarioPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
